import leasingItems from './../static-data/leasing-items.json';

export let getAmortization = name => {
    let amor = '';
    
    leasingItems.map( el => {
        if ( name == el.nazwa || name == el.skrot ) {
            amor = parseFloat(el.amortyzacja);
        }
    })

    return amor;
}